import React, { ReactNode } from 'react';
import "./ActionButton.scss"

interface ActionButtonProps {
  className?: string;                        // Additional CSS classes for styling
  disabled?: boolean;                        // Whether the button is disabled
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void; // Optional click event handler
  type?: 'button' | 'submit' | 'reset';      // Button type (default is "button")
  form?: string;                             // Form ID to associate the button with
  id?: string;                               // Optional ID for the button
  children: ReactNode;                       // Content inside the button
}

const ActionButton: React.FC<ActionButtonProps> = ({
  className = "",
  disabled = false,
  onClick,
  type = "button",
  form,
  id,
  children,
}) => {
  return (
    <button
      className={`fancyButton ${className}`}
      disabled={disabled}
      onClick={onClick}
      type={type}
      form={form}
      id={id}
    >
      {children}
      <div className="fancyButton__horizontal"></div>
      <div className="fancyButton__vertical"></div>
    </button>
  );
};

export default ActionButton;
